import { render, staticRenderFns } from "./BAnimatingBtn.vue?vue&type=template&id=4284de6a&scoped=true"
import script from "./BAnimatingBtn.vue?vue&type=script&lang=js"
export * from "./BAnimatingBtn.vue?vue&type=script&lang=js"
import style0 from "./BAnimatingBtn.vue?vue&type=style&index=0&id=4284de6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284de6a",
  null
  
)

export default component.exports